<template>
    <div class="location-tile">
        <div class="company-logo">
            <img :src="location.icon" alt="">
        </div>
        <div class="company-teaser">
            <div class="tag-list">
                <span v-if="location.distance" class="tag">
                    {{ Number(location.distance).toFixed(2) }} KM
                </span>
                <span v-for="(tag, index) in location.tags" :key="`tag-${index}`" class="tag"
                      :class="'tag-' + formatTagClass(tag)">
                    {{ tag }}
                </span>
            </div>
            <p>{{ location.teaser_text }}</p>
        </div>
        <div class="location-info" :class="{ expanded: expanded }">
            <div class="expanded-content">
                <div class="address">
                    <div class="icon-headline">
                        <span class="icon" :style="`mask-image: url('${iconPath}address.svg');`"/>
                        <h4>{{ translate(translations, 'location.address') }}</h4>
                    </div>
                    <div class="info">
                        <div class="company-name">
                            {{ location.name }}
                        </div>
                        <div class="company-address">
                            {{ location.address }}<br>
                            {{ location.zip }} {{ location.city }}
                        </div>
                    </div>
                </div>
                <div v-if="location.phone" class="phone">
                    <div class="icon-headline">
                        <span class="icon" :style="`mask-image: url('${iconPath}phone.svg');`"/>
                        <h4>{{ translate(translations, 'location.contact') }}</h4>
                    </div>
                    <div class="info">
                        <a :href="`tel:${location.phone}`">{{ location.phone }}</a>
                    </div>
                </div>
                <div v-if="location.link" class="website">
                    <div class="icon-headline">
                        <span class="icon" :style="`mask-image: url('${iconPath}website.svg');`"/>
                        <h4>{{ translate(translations, 'location.website') }}</h4>
                    </div>
                    <div class="info">
                        <a :href="location.link">{{ location.link }}</a>
                    </div>
                </div>
                <div v-if="location.contactFormLink" class="contact-form">
                    <div class="icon-headline">
                        <span class="icon" :style="`mask-image: url('${iconPath}contact.svg');`"/>
                        <h4>{{ translate(translations, 'location.contactform') }}</h4>
                    </div>
                    <div class="info">
                        <a :href="location.contactFormLink">{{ location.contactFormLink }}</a>
                    </div>
                </div>
                <div v-if="location.customerPortalLink" class="customer-portal">
                    <div class="icon-headline">
                        <span class="icon" :style="`mask-image: url('${iconPath}customer.svg');`"/>
                        <h4>{{ translate(translations, 'location.customerportal') }}</h4>
                    </div>
                    <div class="info">
                        <a :href="location.customerPortalLink">{{ location.customerPortalLink }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="expander" @click="expand">
            <img v-if="!expanded" src="@images-locations/arrow-down.svg" alt="expand">
            <img v-if="expanded" src="@images-locations/arrow-up.svg" alt="expand">
        </div>
    </div>
</template>


<script>
import { ref } from 'vue';
import { translate } from '../translate';

export default {
	name: 'CompanyList',
	props: {
		location: {
			type: Object,
			required: true,
		},
		iconPath: {
			type: String,
			required: true,
		},
		translations: {
			type: Object,
			required: true,
		},
	},
	setup() {
		const windowWidth = ref(window.innerWidth);
		const expanded = ref(false);

		window.addEventListener('resize', () => {
			windowWidth.value = window.innerWidth;
		});

		const formatTagClass = (tag) => {
			return tag.toLowerCase().replace(/\s+/g, '-');
		};

		const expand = () => {
			expanded.value = !expanded.value;
		};

		return {
			translate,
			expanded,
			expand,
			formatTagClass,
		};
	},
};
</script>
